export default "__VITE_ASSET__Bcysj0qQ__"